export default __webpack_public_path__ + "static/media/node-dot-js.cca88671.svg";